import React from 'react'
import ImagesPreview from '../update-case/imagesPreview'

function formatTagList(items) {
    if (!items || !items.length || !items[0]) {
        return []
    }
    return items
}

function ShowPreview({ caseData }) {
    const comorbidities = formatTagList(caseData?.comorbidities)
    const complications = formatTagList(caseData?.complications)

    return (
        <div className="casePreview">
            <article className="widgetWrap detailWidget casePreviewDetails">
                <div className="widgetHeader">
                    <span>Case Details</span>
                </div>
                <ul className="listUnstyled casePreviewDetailGrid">
                    <li>
                        <span className="txTitle">Case Ref</span>
                        <span className="txDetail textCapitalize">{caseData?.reference || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Gender</span>
                        <span className="txDetail textCapitalize">{caseData?.gender || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Age</span>
                        <span className="txDetail">{caseData?.age || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Group</span>
                        <span className="txDetail textCapitalize">{caseData?.group || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Consultant</span>
                        <span className="txDetail">{caseData?.consultant || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Procedure</span>
                        <span className="txDetail textCapitalize">{caseData?.procedure || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Status</span>
                        <span className="txDetail textCapitalize">{caseData?.status?.replace(/-/g, ' ') || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Procedure Date</span>
                        <span className="txDetail">{caseData?.date || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Case Uploaded</span>
                        <span className="txDetail">{caseData?.created_at || '-'}</span>
                    </li>
                    <li>
                        <span className="txTitle">Operative Time</span>
                        <span className="txDetail">{caseData?.operative_time ? `${caseData?.operative_time} Hrs` : '-'}</span>
                    </li>
                </ul>
            </article>

            <div className="clinicalCardRow">
                <article className="widgetWrap historyWidget">
                    <div className="widgetHeader">
                        <span>Past Medical History</span>
                    </div>
                    <div className="widgetBody">
                        <p className="casePreviewText">
                            {caseData?.past_medical_history || 'No past medical history recorded.'}
                        </p>
                    </div>
                </article>
                <article className="widgetWrap noteWidget">
                    <div className="widgetHeader">
                        <span>Notes</span>
                    </div>
                    <div className="widgetBody">
                        <p className="casePreviewText">
                            {caseData?.note || 'No notes recorded.'}
                        </p>
                    </div>
                </article>
            </div>

            <div className="clinicalCardRow tagsCardRow">
                <article className="widgetWrap comoWidget">
                    <div className="widgetHeader">
                        <span>Comorbidities</span>
                    </div>
                    <div className="widgetBody">
                        {comorbidities.length > 0 ? (
                            <ul className="listUnstyled tagList multiTagList casePreviewTags">
                                {comorbidities.map((item, index) => (
                                    <li key={`${item}-${index}`}>{item}</li>
                                ))}
                            </ul>
                        ) : (
                            <p className="casePreviewEmpty">No comorbidities selected.</p>
                        )}
                    </div>
                </article>
                <article className="widgetWrap compWidget">
                    <div className="widgetHeader">
                        <span>Complications</span>
                    </div>
                    <div className="widgetBody">
                        {complications.length > 0 ? (
                            <ul className="listUnstyled tagList multiTagList casePreviewTags">
                                {complications.map((item, index) => (
                                    <li key={`${item}-${index}`}>{item}</li>
                                ))}
                            </ul>
                        ) : (
                            <p className="casePreviewEmpty">No complications selected.</p>
                        )}
                    </div>
                </article>
            </div>

            {(caseData.images && caseData.images.length > 0) && (
                <div className="casePreviewImages">
                    <ImagesPreview caseData={caseData} />
                </div>
            )}
        </div>
    )
}

export default ShowPreview
